import { createAsyncThunk } from "@reduxjs/toolkit";
import { InsightsHubArticle } from "@insightsHub/models";
import { mapStrapiPortalArticle } from "@insightsHub/util/mapStrapiPortalArticle";
import { ThunkApiConfig } from "@shared/models/redux";
import { openNotificationThunk } from "@store/Notification/thunks";
import { homeNotificationMessage } from "@home/constants";
import { callFeaturedInsightsAPI } from "@home/store/thunks/callFeaturedInsightsAPI";

export const fetchFeaturedInsights = createAsyncThunk<InsightsHubArticle[], void, ThunkApiConfig>(
  "home/fetchFeaturedInsights",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await dispatch(callFeaturedInsightsAPI());
      const articles = Array.isArray(response?.data) ? response.data : [];

      return articles.filter(Boolean).map((articleDto) => mapStrapiPortalArticle(articleDto));
    } catch (error) {
      console.error(error);

      dispatch(openNotificationThunk({ variant: "warning", text: homeNotificationMessage.featuredInsightsWarning }));

      return rejectWithValue("Failed to fetch Featured Insights");
    }
  },
  {
    condition: (_, { getState }) => {
      const { data, loading } = getState().home.featuredInsights;

      return !data && !loading;
    },
  }
);
